module.exports = __webpack_public_path__ + "static/media/financepic1@2x.54dade02.png";